module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"DiagnosisPublished":"გამოქვეყნდა","final":"საბოლოო დიაგნოზი","preliminary":"წინასწარი დიაგნოზი"},"en":{"DiagnosisPublished":"Published","final":"Final Diagnosis","preliminary":"Preliminary Diagnosis"}}')
  delete Component.options._Ctor
}
